import EventEmitter from 'eventemitter3';
import { Api, APIResponse, Fetch, Methods, RouteGeneratorFn } from './api';
import { AuthenticationError, PermissionDeniedError } from './error';

type ApiEventEmitter = EventEmitter<'session invalid'>;

export interface AuthFailureEmittingApi {
  emitter: ApiEventEmitter;
}

export class BlueJApi extends Api implements AuthFailureEmittingApi {
  public emitter: ApiEventEmitter;

  constructor(backendUrl = '', overriddenFetch?: Fetch | undefined) {
    super(backendUrl, overriddenFetch);
    this.emitter = new EventEmitter();
  }

  protected override createFetch<TPayload, TResponse, TParams>(apiSubRoute: string | RouteGeneratorFn<TParams>, method: Methods = 'POST'): (payload?: TPayload, params?: TParams) => APIResponse<TResponse> {
    const fetcher = super.createFetch<TPayload, TResponse, TParams>(apiSubRoute, method);

    return (payload?: TPayload, params?: TParams): APIResponse<TResponse> => {
      const response = fetcher(payload, params);
      response.parsedResponse().catch((err) => {
        // Only emitting auth related events that are a result of having a bad session
        if (err instanceof AuthenticationError || err instanceof PermissionDeniedError && err.isRevoked()) {
          this.emitter.emit('session invalid', { err });
        }
      });
      return response;
    }
  }
}
